import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "Role/";

const getRoles = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetRoles', constants.REQUIRE_INTERCEPTORS);

const savePayRate = async (id, straightPayRate, otPayRate) => await axiosInstance.post(ENDPOINTORIGIN + 'SavePayRate?id=' + id + '&straightPayRate=' + straightPayRate + '&overTimePayRate=' + otPayRate, {}, constants.REQUIRE_INTERCEPTORS);

export {
    getRoles,
    savePayRate
}